import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const notOneOf = (values: unknown[], error?: string): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    return values.includes(control.value)
      ? { notOneOf: error ?? true }
      : // Return null if validation passes
        null;
  };
};
